import React from 'react';
import { Form } from "semantic-ui-react";
import { useFormik } from 'formik';
import { Document } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./DocumentForm.form";

const documentController = new Document();

export function DocumentForm(props) {

  const { onClose, onReload, document } = props;
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: initialValues(document),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const data = {
          name: formValue.name,
        };

        if (document) {
          await documentController.updateDocument(accessToken, document.id, data);
        } else {
          data.status = 1;
          await documentController.createDocument(accessToken, data);
        }
        onReload();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Input
        name="name"
        label="Nombre de documento"
        onChange={formik.handleChange}
        value={formik.values.name}
        error={formik.errors.name}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {document ? "Actualizar documento" : "Crear documento"}
      </Form.Button>
    </Form>
  )
}
